<template>
  <b-row>
    <b-col
      md="12"
    >
      <b-form-group
        label="Type"
        label-size="sm"
      >
        <validation-provider
          #default="{ errors }"
          name="slot type"
          rules="required"
        >
          <v-select
            id="slot-type"
            v-model="content.type"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :reduce="(text) => text.value"
            label="text"
            :options="typeIbn"
            :state="errors.length > 0 ? false : null"
            @input="setType"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <!-- <b-col
      v-if="content.type === 2"
      md="12"
    >
      <b-form-group
        label="Menu Type"
        label-size="sm"
      >
        <validation-provider
          #default="{ errors }"
          name="menu_type"
          rules="required"
        >
          <v-select
            id="menu-type"
            v-model="content.menu_type"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :reduce="(text) => text.value"
            label="text"
            :options="typeMenu"
            :state="errors.length > 0 ? false : null"
            @input="setTypeMenu"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col> -->
    <!-- type interestial -->
    <b-col
      v-if="(content.type === 1 || content.type === 2)"
      md="6"
    >
      <b-form-group
        label="Banner 300 x 250 px"
        label-for="banner"
      >
        <validation-provider
          #default="{ errors }"
          name="Banner"
          rules="required|dimensions300x250"
        >
          <b-form-file
            id="banner"
            v-model="content.banner"
            name="banner-landscape"
            accept="image/*"
            placeholder="Upload Image"
            :state="errors.length > 0 ? false : null"
            @change="onFileChange"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col
      v-if="content.type === 3"
      md="6"
    >
      <b-form-group
        label="Label"
        label-for="label"
      >
        <validation-provider
          #default="{ errors }"
          name="Label"
          rules="required"
        >
          <b-form-input
            id="label"
            v-model="content.label"
            name="label"
            placeholder="Type your label"
            rows="3"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col
      md="6"
    >
      <b-form-group
        label="Action Link"
        label-for="action-link"
      >
        <validation-provider
          #default="{ errors }"
          name="Action Link"
          rules="required"
        >
          <b-form-input
            id="action-link"
            v-model="content.action_link"
            name="action_link"
            placeholder="domain.com/xxxxx"
            rows="3"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <!-- type popup menu -->
    <!-- <b-col
      v-if="(content.menu_type === 1 && content.type === 2)"
      md="4"
    >
      <b-form-group
        label="Icon"
        label-for="icon"
      >
        <validation-provider
          #default="{ errors }"
          name="icon"
          rules="required"
        >
          <b-form-file
            id="icon"
            v-model="content.icon"
            name="icon"
            accept="image/*"
            placeholder="Upload Image"
            :state="errors.length > 0 ? false : null"
            @change="onFileChange"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col
      v-if="(content.menu_type === 1 && content.type === 2)"
      md="4"
    >
      <b-form-group
        label="Label"
        label-for="label"
      >
        <validation-provider
          #default="{ errors }"
          name="label"
          rules="required"
        >
          <b-form-input
            id="label"
            v-model="content.label"
            name="label"
            placeholder="Type your label"
            rows="3"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col
      v-if="(content.menu_type === 1 && content.type === 2)"
      md="4"
    >
      <b-form-group
        label="Action Link"
        label-for="action-link"
      >
        <validation-provider
          #default="{ errors }"
          name="action_link"
          rules="required"
        >
          <b-form-input
            id="action-link"
            v-model="content.action_link"
            name="action_link"
            placeholder="domain.com/xxxxx"
            rows="3"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col> -->
    <img
      :src="url"
      alt=""
    >
  </b-row>
</template>
<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BFormFile,
} from 'bootstrap-vue'
import { regex } from 'vee-validate/dist/rules'
import { ValidationProvider, extend } from 'vee-validate'
import vSelect from 'vue-select'
import { mapMutations } from 'vuex'
// import { mapMutations } from 'vuex'

// ieu validasi hese
// eslint-disable-next-line no-unused-vars
const util = file => new Promise((resolve, reject) => {
  let reader = new FileReader()
  reader.onload = e => {
    let data = e.target.result
    let img = new Image()
    img.src = data
    img.onload = () => {
      resolve({
        width: img.width,
        height: img.height,
      })
    }
  }
  reader.readAsDataURL(file)
})

extend('regex', {
  ...regex,
  message: 'This {_field_} field must be numeric!',
})

// extend('dimensions320x50', {
//   message: 'File dimensions {_field_} field must be 320 x 50 pixel',
//   validate: async value => {
//     let img = await util(value)
//     if (img.width === 320 && img.height === 50) return true
//     return false
//   },
// })

extend('dimensions300x250', {
  message: 'File dimensions {_field_} field must be 300 x 250 pixel',
  validate: async value => {
    let img = await util(value)
    if (img.width === 300 && img.height === 250) return true
    return false
  },
})

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormFile,
    ValidationProvider,
    vSelect,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    method: Number,
  },
  data() {
    return {
      medium_select: '',
      content: {
        type: 1,
        type_name: 'Banner',
        // menu_type: null,
        // menu_type_name: '',
        action_link: '',
        banner: null,
        // icon: null,
        label: '',
      },
      url: '',
      typeIbn: [
        { value: 1, text: 'Banner' },
        { value: 2, text: 'Interestial' },
        { value: 3, text: 'Menu List' },
      ],
      // typeMenu: [
      //   { value: 1, text: 'List Menu' },
      //   { value: 2, text: 'Banner' },
      // ],
    }
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    ...mapMutations('campaign', {
      setBannerUrl: 'SET_BANNER_IBN_URL',
      setIconUrl: 'SET_ICON_IBN_URL',
    }),
    setContent() {
      this.$store.state.campaign.formCampaign.content = this.content
    },
    onFileChange(e) {
      const file = e.target.files[0]
      // console.log(e.target.id)
      if (e.target.id === 'banner') {
        this.$store.state.campaign.formCampaign.banner = file
        this.setBannerUrl(URL.createObjectURL(file))
        // console.log(URL.createObjectURL(file))
      }
      if (e.target.id === 'icon') {
        this.$store.state.campaign.formCampaign.icon = file
        this.setIconUrl(URL.createObjectURL(file))
      }
    },
    getText(arr, i) {
      const data = arr.find(item => item.value === i)
      return data.text
    },
    setType(val) {
      this.content.type_name = this.getText(this.typeIbn, val)
      // if (val === 2) {
      //   this.content.menu_type = 1
      //   this.setTypeMenu(1)
      // }
    },
    // setTypeMenu(val) {
    //   this.content.menu_type_name = this.getText(this.typeMenu, val)
    // },
  },
}
</script>
<style scoped>
</style>
